var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"krA8BaqR5iEI33Me1jyd7"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/otvety";

import * as Sentry from '@sentry/nextjs';
import { HttpClient } from '@sentry/integrations';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://0757ccaf22fbf2c95c363136b2830674@sentry.runit.cc/183',
  enableTracing: false,
  tracesSampleRate: 0,
  enabled: process.env.NODE_ENV === 'production',
  integrations: [new HttpClient()],
  sendDefaultPii: true,
  ignoreErrors: [
    'TypeError: Failed to fetch',
    'TypeError: Load failed',
    'TypeError: Cancelled',
    'TypeError: NetworkError when attempting to fetch resource.',
    "SyntaxError: Failed to execute 'evaluate' on 'Document': The string '' is not a valid XPath expression.",
  ],
});
